import { render, staticRenderFns } from "./ActivateSuspendButtons.vue?vue&type=template&id=427658da&scoped=true&"
import script from "./ActivateSuspendButtons.vue?vue&type=script&lang=js&"
export * from "./ActivateSuspendButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427658da",
  null
  
)

export default component.exports